import FormLabel from '../../components/FormLabel';
import { useCheckboxStyles } from './Checkbox.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = ({
  name,
  checked,
  label,
  required,
  isDisabled = false,
  onChange
}) => {
  const {
    wrapperStyle
  } = useCheckboxStyles({
    isDisabled
  });
  const handleChange = e => {
    onChange(name, e.target.checked ? 'true' : 'false');
  };
  return /*#__PURE__*/_jsxs("div", {
    style: wrapperStyle,
    children: [/*#__PURE__*/_jsx("input", {
      id: name,
      type: "checkbox",
      checked: checked,
      onChange: handleChange,
      required: required,
      disabled: isDisabled
    }), /*#__PURE__*/_jsx(FormLabel, {
      label: label,
      required: required,
      htmlFor: name
    })]
  });
};
export default Checkbox;